<template>
  <div id="timeLimit">
    <img class="goBack" @click="goBack" src="../../../assets/images/activity/goBack.png" alt="">
    <div class="searchBox">
      <div v-if="countdownText" class="timeBox">
        {{ countdownText }}
      </div>
      <div class="searchWrap">
        <el-input
          v-model="commodityName"
          clearable
          placeholder="搜索你想要找的商品"
          prefix-icon="el-icon-search"
          class="input-with-select"
        >
          <el-button slot="append" @click="searchGoodStore">搜索</el-button>
        </el-input>
      </div>
    </div>
    <div class="masterMap">
      <img :src="logoUrl" alt="">
    </div>
    <div class="content">
      <template v-if="flashSaleList.length > 0">
        <div class="limitItem" v-for="(value, index) of flashSaleList" :key="index">
          <div class="img">
            <img :src="value.imgs[0].img" alt="">
            <img class="soldOut" v-if="value.reserve <= 0" src="../../../assets/images/activity/soldOut.png" alt="">
          </div>
          <div class="info">
            <div class="storeCommodity">
              <img class="UImg" v-if="value.storeType === 'U'" src="@/assets/images/pt-yxdp.png" alt="">
              <img class="SImg" v-if="value.storeType === 'S'" src="@/assets/images/pt-yxdp.png" alt="">
              <div class="commodityName">{{ value.commodityName }}</div>
            </div>
            <div class="groupNum">
              <div class="left">{{ value.groupPeople }}人团</div>
              <div class="right">已拼成{{ totalSalesNumber(value) }}份</div>
            </div>
            <div class="price">
              <div class="price-box">
                <span class="current-price">
                  <span style="font-size: 10px;margin-right: -4px;" v-if="value.pays && value.pays[0] && value.pays[0].payType === 1">¥</span>
                  {{ minRetailPrice(value.activitySkus, 'discountPrice')?.discountPrice }}
                  <span v-if="value.pays && value.pays[0] && value.pays[0].payType !== 1">提货值</span>
                </span>
                <span class="original-price">
                  <span style="font-size: 10px;margin-right: -2px;" v-if="value.pays && value.pays[0] && value.pays[0].payType === 1">¥</span>
                  {{ minRetailPrice(value.activitySkus, 'discountPrice')?.retailPrice }}
                  <span v-if="value.pays && value.pays[0] && value.pays[0].payType !== 1">提货值</span>
                </span>
              </div>
            </div>
            <div class="groupText">
              浏览器扫描右侧二维码
              <span>参加拼团</span>
            </div>
            <div class="groupCode">
              <vue-qr class="qrStyle" :text="makeQRCode(value.commodityId, value.activityId)" style="display: block; width: 100%; height: 100%;" />
            </div>
          </div>
        </div>
      </template>
      <div class="noData" v-else>
        暂无数据
      </div>
    </div>
    <!-- 加载状态提示 -->
    <div v-if="flashSaleList.length > 0" class="loadingTip">
      <div v-if="loading" class="loading">正在加载<i class="el-icon-loading"></i></div>
      <div v-else-if="noMore" class="noMore">没有更多了</div>
    </div>
  </div>
</template>

<script>
/*global protocol http */
import VueQr from 'vue-qr'
export default {
  components: {
    VueQr
  },
  data() {
    return {
      flashSaleList: [],
      timer: null, // 倒计时定时器
      tabOffsetTop: 0, // 标签初始位置
      commodityName: '', // 搜索信息
      activityId: null, // 活动ID
      logoUrl: null,
      activityStartTime: null,
      activityEndTime: null,
      countdownText: '', // 倒计时文本
      currentPage: 0, // 当前页码
      pageSize: 8, // 每页数量
      loading: false, // 加载中状态
      noMore: false, // 是否没有更多数据
      statusOrder: 0, // 订单状态
      totalPages: 0 // 总页数
    }
  },
  computed: {
    // 从 Vuex 获取活动ID
    groupActivityIdFromStore() {
      return this.$store.state.pt.groupActivityId
    },
    // 从 Vuex 获取服务器时间偏移量
    serverTimeOffset() {
      return this.$store.state.common.serverTimeOffset || 0
    }
  },
  created() {
    // 从 Vuex 读取 activityId
    this.activityId = this.groupActivityIdFromStore
    this.queryAllflashSale()
  },
  mounted() {
    // 监听滚动事件
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    // 清除定时器
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
    // 移除滚动监听
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    // 生成拼团二维码
    makeQRCode(commodityId, activityId) {
      const baseUrl = window.g.REGISTER_URLS
      const currentUserId = this.sessionInfoGetter?.userId || sessionStorage.getItem('userId') || ''
      const url = `${baseUrl}?commodityId=${commodityId}&activityId=${activityId}&userId=${currentUserId}`
      return url
    },
    goBack() {
      this.$router.go(-1)
    },
    // 计算总销售数量
    totalSalesNumber(val) {
      if (this.statusOrder === 2) {
        return 0
      }
      if (!val || val === 0) {
        return 0
      }
      return val.activitySkus.reduce((total, sku) => {
        if (sku.display === '1') {
          const initSales = sku.initSalesNumber || 0
          const sales = sku.salesNumber || 0
          return total + initSales + sales
        } else {
          return total
        }
      }, 0)
    },
    // 格式化时间为两位数
    formatTime(num) {
      return num < 10 ? `0${num}` : `${num}`
    },
    // 获取当前服务器时间（修正后的时间）
    getServerTime() {
      return Date.now() + this.serverTimeOffset
    },
    // 计算活动倒计时文本
    calculateActivityCountdown() {
      if (!this.activityStartTime || !this.activityEndTime) {
        return ''
      }
      const now = this.getServerTime() // 使用服务器时间
      const startTime = this.activityStartTime
      const endTime = this.activityEndTime
      // 如果活动还未开始
      if (now < startTime) {
        const diff = startTime - now
        const hours = Math.floor(diff / (1000 * 60 * 60))
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
        const seconds = Math.floor((diff % (1000 * 60)) / 1000)
        return `即将开团 ${this.formatTime(hours)} : ${this.formatTime(minutes)} : ${this.formatTime(seconds)}后开始`
      } else if (now >= startTime && now < endTime) {
        // 如果活动进行中
        const diff = endTime - now
        const hours = Math.floor(diff / (1000 * 60 * 60))
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
        const seconds = Math.floor((diff % (1000 * 60)) / 1000)
        return `拼团中 ${this.formatTime(hours)} : ${this.formatTime(minutes)} : ${this.formatTime(seconds)}后结束`
      } else {
        // 如果活动已结束
        return '拼团结束'
      }
    },
    // 更新活动倒计时
    updateActivityCountdown() {
      this.countdownText = this.calculateActivityCountdown()
    },
    // 启动倒计时定时器
    startCountdownTimer() {
      if (this.timer) {
        clearInterval(this.timer)
      }
      // 立即更新一次
      this.updateActivityCountdown()
      // 每秒更新一次
      this.timer = setInterval(() => {
        this.updateActivityCountdown()
      }, 1000)
    },
    // 筛选skus对象数组中对象的property属性是最小值的对象
    minRetailPrice(skus, property) {
      let min = ''
      let minIndex = ''
      for (let i = 0; i < skus.length; i++) {
        const el = skus[i]
        if (el.display === '1' && (min === '' || el[property] < min)) {
          min = el[property]
          minIndex = i
        }
      }
      if (minIndex === '') {
        return {}
      } else {
        return skus[minIndex]
      }
    },
    // 查询所有拼团
    queryAllflashSale(isLoadMore = false) {
      if (this.loading) return
      this.loading = true

      const apiObj = JSON.parse(JSON.stringify(protocol.param_queryGrouponCommodity))
      apiObj.param = {
        page: isLoadMore ? this.currentPage : 0,
        size: this.pageSize,
        activityId: this.activityId,
        commodityName: this.commodityName,
        sort: [{
          direction: 'DESC',
          property: 'sortId'
        }]
      }
      http.postFrontMall(apiObj).then((res) => {
        const { code, message, value } = res.data
        if (Number(code) === 0) {
          this.logoUrl = value.activityImg.split(',')[1]
          this.statusOrder = value.statusOrder
          const newData = value.shopCommodityPage.content || []

          if (isLoadMore) {
            // 加载更多，追加数据
            this.flashSaleList = [...this.flashSaleList, ...newData]
          } else {
            // 首次加载或搜索，替换数据
            this.flashSaleList = newData
            this.currentPage = 0
            this.noMore = false
          }

          this.activityStartTime = value.startTime
          this.activityEndTime = value.endTime
          this.totalPages = value.shopCommodityPage.totalPages

          // 判断是否还有更多数据
          // 如果返回的数据为空，或者当前页已经是最后一页
          if (newData.length === 0 || this.currentPage >= this.totalPages - 1) {
            this.noMore = true
          }

          // 启动倒计时定时器
          this.startCountdownTimer()
        } else {
          this.$message(message)
        }
      }).catch(() => {
        this.$message.error('加载数据失败，请稍后重试')
      }).finally(() => {
        this.loading = false
        // 在 loading 设置为 false 之后，检查是否需要自动加载
        this.$nextTick(() => {
          this.checkAndLoadMore()
        })
      })
    },
    // 搜索商品或店铺
    searchGoodStore() {
      this.queryAllflashSale()
    },
    // 处理滚动事件
    handleScroll() {
      // 如果正在加载或没有更多数据，则不处理
      if (this.loading || this.noMore) return

      // 获取滚动位置
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      const windowHeight = window.innerHeight
      const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight

      // 判断是否滚动到底部（距离底部100px时触发）
      if (scrollTop + windowHeight >= scrollHeight - 100) {
        this.loadMore()
      }
    },
    // 加载更多数据
    loadMore() {
      if (this.loading || this.noMore) return
      this.currentPage++
      this.queryAllflashSale(true)
    },
    // 检查页面是否有滚动条，如果没有且还有更多数据，自动加载
    checkAndLoadMore() {
      const hasScrollbar = document.documentElement.scrollHeight > document.documentElement.clientHeight

      // 如果没有滚动条且还有更多数据，自动加载下一页
      if (!hasScrollbar && !this.noMore && !this.loading) {
        this.loadMore()
      }
    }
  }
}
</script>
<style scoped lang="scss">
  #timeLimit {
    background: #F4F4F4;
    min-height: calc(100vh - 40px);
    padding-bottom: 50px;
    position: relative;
    .tabBox {
      position: absolute;
      width: 150px;
      height: 192px;
      background: #FFFFFF;
      border-radius: 8px 8px 8px 8px;
      left: 208px;
      top: 500px;
      display: flex;
      flex-direction: column;
      z-index: 100;
      // transition: all 0.3s ease;
      .item {
        flex: 1;
        font-family: PingFang TC, PingFang TC;
        font-weight: 500;
        font-size: 18px;
        color: #333333;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
    }
    .goBack {
      position: absolute;
      top: 30px;
      left: 50px;
      width: 40px;
      height: 40px;
      cursor: pointer;
    }
    .searchBox {
      width: 1200px;
      margin: 0 auto;
      padding: 41px 0 19px;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 34px;
      .timeBox {
        font-family: PingFang TC, PingFang TC;
        font-weight: 400;
        font-size: 16px;
        color: #FE6E4B;
      }
      .searchWrap {
        /deep/ .el-input {
          width: 630px;
          .el-input__inner{
            height: 44px;
            border-radius: 4px 4px 4px 4px;
            background:transparent;
            border: 1px solid #A5A6AC;
            font-size: 12px;
            font-family: Alibaba PuHuiTi-Regular, Alibaba PuHuiTi;
            font-weight: 400;
            color: #999999;
            box-sizing: border-box;
          }
          .el-input__icon {
            line-height: 44px;
            font-size: 12px;
          }
          .el-input-group__append{
            width: 104px;
            height: 44px;
            border:none;
            padding: 0;
            background: #1571DB;
            font-size: 16px;
            text-align: center;
            .el-button {
              span {
                color: #FFFFFF;
              }
            }
          }
        }
      }
      .btns{
        cursor: pointer;
        display: inline-block;
        width: 83px;
        height: 32px;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #D9D9D9;
        // box-sizing: border-box;
        text-align: center;
        font-size: 16px;
        font-family: Alibaba PuHuiTi-Regular, Alibaba PuHuiTi;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 33px;
        margin-left:16px;
      }
    }
    .masterMap {
      width: 1200px;
      height: 300px;
      margin: 0 auto;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .content {
      width: 1200px;
      margin: 0 auto;
      margin-top: 24px;
      display: flex;
      flex-wrap: wrap;
      gap: 21px;
      .limitItem {
        width: 284px;
        height: 390px;
        background: #FFFFFF;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        .img {
          width: 100%;
          height: 282px;
          background: #E4E4E4;
          position: relative;
          img {
            width: 100%;
            height: 100%;
          }
          .soldOut {
            position: absolute;
            width: 200px;
            height: 200px;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            margin: auto;
          }
        }
        .info {
          padding: 10px;
          position: relative;
          .storeCommodity {
            display: flex;
            align-items: center;
            gap: 6px;
            img {
              height: 16px;
            }
            .commodityName {
              font-size: 14px;
              color: #333333;
              flex: 1;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
          .groupNum {
            width: fit-content;
            height: 16px;
            border-radius: 2px 0px 0px 2px;
            border: 1px solid #EB6643;
            display: flex;
            margin: 8px 0;
            .left {
              padding: 0 4px;
              background-color: #EB6643;
              font-family: PingFang TC, PingFang TC;
              font-weight: 400;
              font-size: 10px;
              color: #FFFFFF;
            }
            .right {
              padding: 0 4px;
              background-color: #fff;
              font-family: PingFang TC, PingFang TC;
              font-weight: 300;
              font-size: 10px;
              color: #EB6643;
              text-align: center;
              line-height: 16px;
            }
          }
          .price {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .price-box {
              .current-price {
                font-family: PingFang TC, PingFang TC;
                font-weight: 500;
                font-size: 16px;
                color: #EB6643;
              }
              .original-price {
                font-family: PingFang TC, PingFang TC;
                font-weight: 400;
                font-size: 12px;
                color: #999999;
                text-decoration: line-through;
              }
            }
          }
          .groupText {
            font-family: PingFang TC, PingFang TC;
            font-weight: 400;
            font-size: 10px;
            color: #999999;
            margin-top: 2px;
            span {
              color: #333333;
            }
          }
          .groupCode {
            position: absolute;
            right: 4px;
            bottom: 4px;
            width: 80px;
            height: 80px;
            background: #D9D9D9;
            border-radius: 4px 4px 4px 4px;
          }
        }
      }
      .noData {
        width: 100%;
        height: 200px;
        color: #333333;
        font-size: 18px;
        text-align: center;
        line-height: 200px;
      }
    }
    .loadingTip {
      width: 1200px;
      margin: 20px auto;
      text-align: center;
      font-size: 14px;
      color: #999999;
      .loading {
        color: #1571DB;
      }
      .noMore {
        color: #999999;
      }
    }
  }
</style>
